<template>
  <div style="overflow: hidden">
    <div
      v-if="userWithSameEmail"
      class="h-screen w-full flex justify-center items-center"
    >
      <div
        style="width: 540px; height: 392px; padding-right: 3rem"
        class="relative bg-white pt-12 pl-12 border border-gray-200 shadow-sm"
      >
        <p class="text-3xl leading-9 font-semibold mb-4 text-gray-900">
          Looks like you have an existing account
        </p>
        <p class="text-gray-600 font-normal text-base">
          To link accounts, enter your current password in the field below to
          create a new organization account.
        </p>
        <input
          name="current_password"
          placeholder="Current password"
          type="password"
          v-model="form.existing_password"
          class="shadow-sm mt-4 mr-12 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <input
          class="btn button signup-submit"
          type="button"
          @click="submit"
          :value="submitButtonText"
          tabindex="4"
          :disabled="disableButton"
          data-disable-with="Log in"
        />
        <a
          href="/auth/password/new"
          class="mt-4 block text-base font-normal text-gray-600 underline"
        >
          Forgot your password?
        </a>
        <img
          id="cat-login"
          class="absolute"
          style="top: -45%; right: -15%; z-index: -1"
          :src="require(`images/reactivate_kitty.png`)"
        />
      </div>
    </div>
    <div :class="userWithSameEmail ? 'hidden' : ''" class="row my-0">
      <div class="col-md-6 col-sm-12">
        <div class="signup-main">
          <div class="signup-form-wrapper">
            <div class="form-container-signup smaller-form">
              <div class="subdomain-logo">
                <Logo
                  type="LONG"
                  class="signup-logo w-full"
                />
              </div>
              <p class="signup-p" v-if="urlParam || superOrg">
                Create Your Account
              </p>
              <div v-else>
                <p class="signup-p">
                  Start Your {{ trialDays }}-Day
                  {{ trialAmount === 0 ? 'Free' : '$' + trialAmount }} Trial
                </p>
                <div style="text-align: left">
                  <label>Or</label
                  ><label class="login-start-trail" @click="signInClick">
                    sign in to your account</label
                  >
                </div>
              </div>
              <div>
                <form
                  novalidate="novalidate"
                  class="simple_form new_user mt-4"
                  id="new_user"
                  accept-charset="UTF-8"
                  method="post"
                >
                  <input name="utf8" type="hidden" value="✓" />
                  <fieldset>
                    <div v-if="!isLoginDetailsInParams" class="d-flex">
                      <div class="input optional">
                        <label class="signup-label">First Name</label>
                        <input
                          tabindex="1"
                          autofocus="autofocus"
                          class="string optional"
                          type="text"
                          v-model="form.first_name"
                          placeholder="John"
                        />
                      </div>

                      <div class="input place-last-name">
                        <label class="signup-label">Last Name</label>
                        <input
                          tabindex="2"
                          class="string optional"
                          type="text"
                          v-model="form.last_name"
                          placeholder="Doe"
                        />
                      </div>
                    </div>

                    <div
                      v-if="!isLoginDetailsInParams"
                      class="input email user_email"
                    >
                      <label class="signup-label">Email</label>
                      <input
                        tabindex="3"
                        autofocus="autofocus"
                        class="string email"
                        type="email"
                        v-model="form.email"
                        placeholder="john@example.com"
                      />
                    </div>
                    <div class="input user_password">
                      <label class="signup-label">Password</label>
                      <input
                        tabindex="4"
                        class="password optional"
                        type="password"
                        v-model="form.password"
                        placeholder="Password"
                      />
                    </div>
                    <div v-if="urlParam">
                      <label class="signup-label">Card Details</label>
                      <div class="plan-card">
                        <div ref="card"></div>
                      </div>
                    </div>
                    <div class="signup-policy">
                      <input
                        tabindex="7"
                        type="checkbox"
                        v-model="form.agree_terms"
                      />
                      <label class="signup-policy-label ml-1"
                        >By joining, you agree to the terms of service and
                        privacy policy</label
                      >
                    </div>

                    <div>
                      <input
                        class="btn button signup-submit"
                        type="button"
                        @click="submit"
                        :value="submitButtonText"
                        tabindex="4"
                        :disabled="disableButton"
                        data-disable-with="Log in"
                      />
                    </div>
                    <p
                      class="mt-3 text-sm text-gray-600"
                      v-if="urlParam === 'webinar75'"
                    >
                      After 3 months you will automatically be enrolled <br />
                      in the $99 / month (up to 75 clients) plan. <br />
                      you can cancel or downgrade your account at any time.
                    </p>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="right-container">
          <div v-if="!urlParam">
            <div class="trail-wrapper">
              <svg
                width="43"
                height="35"
                viewBox="0 0 45 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.028 0C5.684 5.184 0.5 13.68 0.5 23.04C0.5 30.672 5.108 35.136 10.436 35.136C15.476 35.136 19.22 31.104 19.22 26.352C19.22 21.6 15.908 18.144 11.588 18.144C10.724 18.144 9.572 18.288 9.284 18.432C10.004 13.536 14.612 7.776 19.22 4.896L13.028 0ZM37.796 0C30.596 5.184 25.412 13.68 25.412 23.04C25.412 30.672 30.02 35.136 35.348 35.136C40.244 35.136 44.132 31.104 44.132 26.352C44.132 21.6 40.676 18.144 36.356 18.144C35.492 18.144 34.484 18.288 34.196 18.432C34.916 13.536 39.38 7.776 43.988 4.896L37.796 0Z"
                  fill="white"
                  fill-opacity="0.25"
                />
              </svg>
              <p style="color: #ffffff">
                Coach Catalyst has the highest client<br />
                use I’ve ever seen. The UX is brilliantly<br />
                simple for the client, so they actually<br />
                use it! The coach side is incredible<br />
                simple yet robust in capibilities.<br /><br />
                10/10 recommend 💪
              </p>
              <p class="right-container-name">Erin Hurst</p>
              <p class="right-container-designation">Atomic Nutrition</p>
              <div class="image-div">
                <img
                  :src="require(`images/Rectangle.png`)"
                  style="height: 100%; width: 90%"
                />
              </div>
            </div>
          </div>
          <div v-if="urlParam === 'webinarUnlimited'">
            <div class="unlimited-plan-wrapper">
              <h3 class="plan-h3">
                Sign up today and get over $12,400 in value including...
              </h3>
              <ul class="plan-list">
                <li>
                  6 months of Coach Catalyst on the Unlimited Plan ($2988 Value)
                </li>
                <li>Inside the Brains Monthly Coaching Calls ($1500 Value)</li>
                <li>7 Day Kickstart Program ($149 Value)</li>
                <li>The MIND Diet Program ($397 Value)</li>
                <li>6-Month Habit Based Coaching Program ($2997 Value)</li>
                <li>Free Branded App for 6 Months ($419 Value)</li>
                <li>1-on-1 Business Strategy Call ($249 Value)</li>
                <li>The Nutrition Coaching Blueprint ($99 Vaule)</li>
              </ul>
            </div>
          </div>
          <div class="cc-plan-wrapper" v-if="urlParam === 'webinar75'">
            <h3 class="plan-h3">
              Sign up today and get over $7800 in value including...
            </h3>
            <ul class="plan-list">
              <li>3 Months of Coach Catalyst on the Pro Plan ($297 Value)</li>
              <li>Clean and Lean Transformation Challenge ($397 Value)</li>
              <li>7 Day Kickstart Program ($149 Value)</li>
              <li>The MIND Diet Program ($397 Value)</li>
              <li>6-Month Habit Based Coaching Program ($2997 Value)</li>
              <li>Transform in 4 Challenge ($297 Value)</li>
              <li>1-on-1 Business Strategy Call ($249 Value)</li>
              <li>The Nutrition Coaching Blueprint ($99 Vaule)</li>
            </ul>
          </div>
          <div v-if="urlParam">
            <div class="plan-bottom-div">
              <p class="plan-p">
                Coach Catalyst has the highest client use I’ve ever seen. The UX
                is<br />brilliantly simple for the client, so they actually use
                it! The coach side<br />is incredible simple yet robust in
                capabilities.
              </p>
              <p>10/10 recommend 💪</p>
              <div class="flex justify-center items-center mt-4">
                <img class="z-10 mr-2" :src="require(`images/avatar.png`)" />
                <p>
                  Erin Hurst<br /><span style="color: #e5e7eb !important"
                    >CEO, Atomic Nutrition</span
                  >
                </p>
              </div>
              <DottedBackground />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ApiUrls from '../../api-url';
  import AuthenticationMixin from '../../authentication-mixin';
  import ValidationMixin from '../../validation-mixin';
  import { mapGetters, mapState } from 'vuex';
  import getters from '../../stores/login-store/getters/login-getters';
  import DottedBackground from '../../svgs/DottedBackground.vue';
  import Logo from '../../components/logos/Logo.vue';

  let style = {
    base: {
      border: '1px solid #D8D8D8',
      borderRadius: '4px',
      color: '#000',
    },
    invalid: {
      // All of the error styles go inside of here.
    },
  };
  let stripe = Stripe(Vue.prototype.$stripe_publish_key, style),
    elements = stripe.elements(),
    card = undefined;
  export default {
    mixins: [ApiUrls, AuthenticationMixin, ValidationMixin],
    components: { DottedBackground,Logo },
    data() {
      return {
        form: {
          first_name: null,
          last_name: null,
          email: null,
          password: null,
          agree_terms: false,
          existing_password: null,
          organization: {
            referral: '',
            referral_text: null,
            linkmink: null,
          },
        },
        disableButton: false,
        userWithSameEmail: false,
        stripeToken: null,
        isLoginDetailsInParams: false,
      };
    },
    async created() {
      await this.$store.commit('setUrlParam', this.$route.query.url_param);
      await this.$store.commit('setAccountType', this.$route.query.accountType);
      await this.$store.commit('setSuperOrg', this.$route.query.superOrg);
      await this.$store.commit('setFbClickId', this.$route.query.fbClickId);
      await this.$store.commit('setCopyCode', this.$route.query.copyCode);
      await this.getPlan();
      try {
        const linkmink = LinkMink('pub_live_Y2uAe3gyQJBmmYcpRBxz');
        const lm_data = linkmink.getReferralData();
        if (lm_data) {
          this.form.organization.linkmink = lm_data;
        }
      } catch (err) {
        console.log(err);
      }
      if (!this.isEmptyObject(this.$route.query)) {
        this.form.first_name = this.$route.query?.firstname || '';
        this.form.last_name = this.$route.query?.lastname || '';
        this.form.email = this.$route.query?.email || '';
        if (
          this.$route.query?.email &&
          this.$route.query?.firstname &&
          this.$route.query?.email
        ) {
          this.isLoginDetailsInParams = true;
        }
      }
    },
    mounted: function () {
      if (this.urlParam) {
        this.$nextTick(() => {
          card = elements.create('card');
          card.mount(this.$refs.card);
          this.$nextTick(() => {
            card.on('change', (event) => {
              if (event.complete) {
                this.disableButton = !event.complete;
              } else if (event.empty || event.error) {
                this.disableButton = true;
              }
            });
            this.validateCard();
          });
        });
      }
    },
    beforeUnmount() {
      if (this.urlParam) card.destroy(this.$refs.card);
    },
    computed: {
      ...mapState([
        'trialAmount',
        'trialDays',
        'urlParam',
        'currentPlan',
        'accountType',
        'superOrg',
        'fbClickId',
        'copyCode',
      ]),
      ...mapGetters(['LOGIN_FORM', 'SIGN_UP_PERSONAL_INFO']),
      submitButtonText() {
        return this.urlParam
          ? `Get Started Today for Just $${
              parseInt(this.currentPlan.amount) / 100
            }`
          : 'Get Started';
      },
    },
    methods: {
      validateCard() {
        card.on('ready', () => {
          this.disableButton = true;
        });
        card.on('focus', () => {
          this.form.agree_terms = false;
        });
      },
      signInClick() {
        this.$router.push({ name: 'SigninPage' });
      },
      async getPlan() {
        let url_param = this.urlParam;
        const response = await axios.post(this.authUrl + 'get_plan', {
          url_param,
        });
        this.$store.commit('setCurrentPlan', response.data.result);
      },
      isValid() {
        if (!this.form.first_name) {
          this.$toast.show('First name required.', this.toasted_options.error);
          return false;
        }

        if (!this.form.last_name) {
          this.$toast.show('Last name required.', this.toasted_options.error);
          return false;
        }

        if (!this.validEmail(this.form.email)) {
          this.$toast.show('Invalid email.', this.toasted_options.error);
          return false;
        }

        if (!this.validPassword(this.form.password)) {
          this.$toast.show(
            'Password must be at least 6 characters.',
            this.toasted_options.error
          );
          return false;
        }
        if (!this.form.agree_terms) {
          this.$toast.show(
            'Please agree to the terms of service.',
            this.toasted_options.error
          );
          return false;
        }
        return true;
      },
      async submit() {
        if (this.isValid()) {
          this.disableButton = true;
          const self = this;
          grecaptcha.ready(function () {
            grecaptcha
              .execute('6LfiNc4ZAAAAAA7O27dikuMBReTDKH_QeP6sLmxn', {
                action: 'submit',
              })
              .then(async (token) => {
                window.fpr('referral', { email: self.form.email });
                self.$emit('save-user', self.form);

                const result = await axios.post('/auth', {
                  user: self.form,
                  token: token,
                  accountType: self.accountType,
                  superOrg: self.superOrg,
                  fbClickId: self.fbClickId,
                  copyCode: self.copyCode,
                  existing_password: self.existing_password,
                });

                console.log(result.data);
                if (result.data.success) {
                  self.userWithSameEmail = false;
                  if (self.urlParam) {
                    document.body.style.cursor = 'wait';
                    stripe.createToken(card).then(async (result) => {
                      await self.submitResponse(result.token);
                    });
                  } else {
                    self.$store.commit(
                      'setSelectedStep',
                      getters.SIGN_UP_PERSONAL_INFO()
                    );
                  }
                } else {
                  self.disableButton = false;
                  if (
                    result.data.error.indexOf(
                      'Please select a different email.'
                    ) > -1
                  ) {
                    self.userWithSameEmail = true;
                  } else {
                    self.$toast.show(
                      result.data.error.replace('uncaught throw', ''),
                      self.toasted_options.error
                    );
                  }
                }
              });
          });
        } else {
          this.$store.commit(
            'setSelectedStep',
            getters.SIGN_UP_CREATE_ACCOUNT()
          );
        }
      },
      async submitResponse(token) {
        let response = await axios.post(
          this.billingUrl + 'update_billing_plan',
          {
            plan: this.currentPlan,
            token: token,
            url_param: this.urlParam,
            background: true,
          }
        );
        document.body.style.cursor = 'default';
        if (response.data.success) {
          this.$store.commit(
            'setSelectedStep',
            getters.SIGN_UP_PERSONAL_INFO()
          );
        } else {
          this.$toast.show(response.data.result, this.toasted_options.error);
          this.disableButton = false;
        }
      },
      isEmptyObject(obj) {
        return JSON.stringify(obj) === '{}';
      },
    },
  };
</script>
